/* global THREE */
import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";

const vertexProgram = `
  varying vec3 viewNormal;

  void main() {
    viewNormal = normalize(normalMatrix * normal);
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
  }
`;

const fragmentProgram = `
  varying vec3 viewNormal;

  uniform vec3 color;
  uniform float opacity;
  uniform float fade;

  void main() {
    float rim = 1.0 - dot(vec3(0,0,1), viewNormal);
    float alpha = smoothstep(fade-0.01, fade+0.01, sqrt(rim));

    gl_FragColor = vec4(color, opacity*alpha);
  }
`;

aframe.registerComponent("explosion-shader", {
  schema: {
    color: { type: "color", default: "red" },
    opacity: { type: "number", default: 0.75, min: 0, max: 1 },
    fade: { type: "number", default: 0, min: 0, max: 1 }
  },
  init: function() {
    this.color = new THREE.Color();
    this._updateUniforms();
    this.material = new THREE.ShaderMaterial({
      uniforms: this._uniforms,
      vertexShader: vertexProgram,
      fragmentShader: fragmentProgram
    });
    this.material.depthWrite = false;
    this.material.transparent = true;
    if ("mesh" in this.el.object3DMap) {
      this._applyShader();
    }
  },
  update: function(oldData) {
    this._updateUniforms();
  },
  _updateUniforms: function() {
    if (this._uniforms === undefined) {
      this._uniforms = {};
    }
    this._uniforms.color = { value: this.color.set(this.data.color) };
    this._uniforms.opacity = { value: this.data.opacity };
    this._uniforms.fade = { value: this.data.fade };
  },
  object3dset: bindEvent(function(evt) {
    if (evt.detail.type === "mesh") {
      this._applyShader();
    }
  }),
  _applyShader() {
    this.el.getObject3D("mesh").material = this.material;
  }
});
